export const environment = {
    webappsRootURL: 'https://testapps.epa.ohio.gov',
    ebizRootURL: 'https://epatestapps.epa.ohio.gov',
    clientID: '759a6548-54f3-4338-9f91-99af20dd7c93',
    redirectURI: 'https://gwqcp.test.epa.ohio.gov/'
};
